
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Menu, X, Phone, Mail, ChevronDown, Home, Lightbulb, Cpu, Wrench, FolderOpen, MessageSquare, Calculator } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeMegaMenu, setActiveMegaMenu] = useState<string | null>(null);

  const megaMenuItems = {
    soluciones: [
    { title: 'HomeSeer', desc: 'Control personalizado y local', icon: <Cpu className="w-5 h-5" data-id="z1d1iwkzb" data-path="src/components/Header.tsx" /> },
    { title: 'Insteon', desc: 'Comunicación dual confiable', icon: <Lightbulb className="w-5 h-5" data-id="k8pdsh4vw" data-path="src/components/Header.tsx" /> },
    { title: 'Fibaro', desc: 'Diseño europeo elegante', icon: <Home className="w-5 h-5" data-id="lrdno7n0j" data-path="src/components/Header.tsx" /> },
    { title: 'Lutron', desc: 'Iluminación profesional', icon: <Lightbulb className="w-5 h-5" data-id="avxyl0c7z" data-path="src/components/Header.tsx" /> }],

    servicios: [
    { title: 'Asesoría Experta', desc: 'Análisis y planificación', icon: <MessageSquare className="w-5 h-5" data-id="xrjj0v4n2" data-path="src/components/Header.tsx" /> },
    { title: 'Venta de Equipos', desc: 'Mejores marcas, precios competitivos', icon: <FolderOpen className="w-5 h-5" data-id="l7nchb5rp" data-path="src/components/Header.tsx" /> },
    { title: 'Instalación', desc: 'Configuración profesional', icon: <Wrench className="w-5 h-5" data-id="k842hhas1" data-path="src/components/Header.tsx" /> },
    { title: 'Soporte', desc: 'Garantía y asistencia continua', icon: <Phone className="w-5 h-5" data-id="wiboam387" data-path="src/components/Header.tsx" /> }]

  };

  const handleMegaMenuEnter = (menu: string) => {
    setActiveMegaMenu(menu);
  };

  const handleMegaMenuLeave = () => {
    setActiveMegaMenu(null);
  };

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50" data-id="0g4kggr48" data-path="src/components/Header.tsx">
      {/* Top Bar */}
      <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white py-2" data-id="3rdxp4vaq" data-path="src/components/Header.tsx">
        <div className="container mx-auto px-4 flex justify-between items-center text-sm" data-id="l21ukou9i" data-path="src/components/Header.tsx">
          <div className="flex items-center space-x-4" data-id="2xgjviebl" data-path="src/components/Header.tsx">
            <div className="flex items-center space-x-2" data-id="ctjt8cc59" data-path="src/components/Header.tsx">
              <Phone className="w-4 h-4" data-id="0sxxrip8x" data-path="src/components/Header.tsx" />
              <span data-id="rmub3xcpd" data-path="src/components/Header.tsx">55.6251.7774</span>
            </div>
            <div className="flex items-center space-x-2" data-id="h8pd8xr2h" data-path="src/components/Header.tsx">
              <Mail className="w-4 h-4" data-id="0tmzo4qgc" data-path="src/components/Header.tsx" />
              <span data-id="ktcmqbp94" data-path="src/components/Header.tsx">nathan@automatiza.me</span>
            </div>
          </div>
          <div className="hidden md:block" data-id="es65hetac" data-path="src/components/Header.tsx">
            <span className="font-medium" data-id="hwk7obkwl" data-path="src/components/Header.tsx">🎯 Cotización Gratuita • 25 años de experiencia</span>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <div className="container mx-auto px-4 py-4" data-id="idbbz8qsg" data-path="src/components/Header.tsx">
        <div className="flex items-center justify-between" data-id="g6wmk8pus" data-path="src/components/Header.tsx">
          {/* Logo */}
          <div className="flex items-center space-x-2" data-id="tkxyhhnro" data-path="src/components/Header.tsx">
            <img
              src="https://b447696.smushcdn.com/447696/wp-content/uploads/2019/07/logo.png?lossy=1&strip=1&webp=1"
              alt="Automatiza.me"
              className="h-12 w-auto" data-id="vkzxfm6hv" data-path="src/components/Header.tsx" />

            <div data-id="we791adt5" data-path="src/components/Header.tsx">
              
              
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8" data-id="wif2t71m9" data-path="src/components/Header.tsx">
            <a href="#inicio" className="text-gray-700 hover:text-blue-600 transition-colors" data-id="yanmis0ek" data-path="src/components/Header.tsx">
              Inicio
            </a>
            <a href="#domotica" className="text-gray-700 hover:text-blue-600 transition-colors" data-id="obz2s57mj" data-path="src/components/Header.tsx">
              ¿Qué es la Domótica?
            </a>
            
            {/* Mega Menu - Soluciones */}
            <div
              className="relative"
              onMouseEnter={() => handleMegaMenuEnter('soluciones')}
              onMouseLeave={handleMegaMenuLeave} data-id="fmnc2srz3" data-path="src/components/Header.tsx">

              <button className="flex items-center space-x-1 text-gray-700 hover:text-blue-600 transition-colors" data-id="ci8jg1awc" data-path="src/components/Header.tsx">
                <span data-id="7jd92gigq" data-path="src/components/Header.tsx">Soluciones</span>
                <ChevronDown className="w-4 h-4" data-id="xxhy7yskp" data-path="src/components/Header.tsx" />
              </button>
              {activeMegaMenu === 'soluciones' &&
              <div className="absolute top-full left-0 mt-2 w-80 bg-white rounded-lg shadow-xl border p-6 z-50" data-id="q88size4d" data-path="src/components/Header.tsx">
                  <div className="grid grid-cols-1 gap-4" data-id="gjgr227mg" data-path="src/components/Header.tsx">
                    {megaMenuItems.soluciones.map((item, index) =>
                  <a
                    key={index}
                    href="#"
                    className="flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="a5xfldy01" data-path="src/components/Header.tsx">

                        <div className="text-blue-600" data-id="a9pm3xcjy" data-path="src/components/Header.tsx">{item.icon}</div>
                        <div data-id="sjraglpu1" data-path="src/components/Header.tsx">
                          <h4 className="font-semibold text-gray-800" data-id="tylzwk2x5" data-path="src/components/Header.tsx">{item.title}</h4>
                          <p className="text-sm text-gray-600" data-id="p6cmknn7p" data-path="src/components/Header.tsx">{item.desc}</p>
                        </div>
                      </a>
                  )}
                  </div>
                </div>
              }
            </div>

            {/* Mega Menu - Servicios */}
            <div
              className="relative"
              onMouseEnter={() => handleMegaMenuEnter('servicios')}
              onMouseLeave={handleMegaMenuLeave} data-id="o2y0ebxb6" data-path="src/components/Header.tsx">

              <button className="flex items-center space-x-1 text-gray-700 hover:text-blue-600 transition-colors" data-id="hcw9b0i1h" data-path="src/components/Header.tsx">
                <span data-id="5lwl23cnu" data-path="src/components/Header.tsx">Servicios</span>
                <ChevronDown className="w-4 h-4" data-id="5ioqo1nak" data-path="src/components/Header.tsx" />
              </button>
              {activeMegaMenu === 'servicios' &&
              <div className="absolute top-full left-0 mt-2 w-80 bg-white rounded-lg shadow-xl border p-6 z-50" data-id="heoycnd3a" data-path="src/components/Header.tsx">
                  <div className="grid grid-cols-1 gap-4" data-id="zyj8duyyq" data-path="src/components/Header.tsx">
                    {megaMenuItems.servicios.map((item, index) =>
                  <a
                    key={index}
                    href="#"
                    className="flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="bq6whx10n" data-path="src/components/Header.tsx">

                        <div className="text-blue-600" data-id="6li72izpx" data-path="src/components/Header.tsx">{item.icon}</div>
                        <div data-id="75ffjweca" data-path="src/components/Header.tsx">
                          <h4 className="font-semibold text-gray-800" data-id="kot5f64ub" data-path="src/components/Header.tsx">{item.title}</h4>
                          <p className="text-sm text-gray-600" data-id="nrwzq2ok3" data-path="src/components/Header.tsx">{item.desc}</p>
                        </div>
                      </a>
                  )}
                  </div>
                </div>
              }
            </div>

            <a href="#proyectos" className="text-gray-700 hover:text-blue-600 transition-colors" data-id="ys2rr8y1e" data-path="src/components/Header.tsx">
              Proyectos
            </a>
            <a href="#testimonios" className="text-gray-700 hover:text-blue-600 transition-colors" data-id="xzom13otj" data-path="src/components/Header.tsx">
              Testimonios
            </a>
            <a href="/blog" className="text-gray-700 hover:text-blue-600 transition-colors" data-id="c6yzbiwff" data-path="src/components/Header.tsx">
              Blog
            </a>
            <a href="/videos" className="text-gray-700 hover:text-blue-600 transition-colors" data-id="mfeh8vx44" data-path="src/components/Header.tsx">
              Videos
            </a>
            <a href="#calculadora" className="text-gray-700 hover:text-blue-600 transition-colors flex items-center space-x-1" data-id="44k6bk3wv" data-path="src/components/Header.tsx">
              <Calculator className="w-4 h-4" data-id="laochlznv" data-path="src/components/Header.tsx" />
              <span data-id="9mp1c37kk" data-path="src/components/Header.tsx">Comparador</span>
            </a>
            <a href="#contacto" className="text-gray-700 hover:text-blue-600 transition-colors" data-id="y3qnul0l0" data-path="src/components/Header.tsx">
              Contacto
            </a>
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:block" data-id="ih4196m4b" data-path="src/components/Header.tsx">
            <Button className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white px-6 py-2 rounded-lg font-medium transition-all duration-300 transform hover:scale-105" data-id="6ayrfnlyx" data-path="src/components/Header.tsx">
              Cotización Gratuita
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
            onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="osoga27ex" data-path="src/components/Header.tsx">

            {isMenuOpen ? <X className="w-6 h-6" data-id="unqd7mw2m" data-path="src/components/Header.tsx" /> : <Menu className="w-6 h-6" data-id="f22i5qnyq" data-path="src/components/Header.tsx" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen &&
      <div className="lg:hidden bg-white border-t" data-id="pdgl8hqnh" data-path="src/components/Header.tsx">
          <div className="container mx-auto px-4 py-4 space-y-4" data-id="ff17ujliu" data-path="src/components/Header.tsx">
            <a href="#inicio" className="block py-2 text-gray-700 hover:text-blue-600 transition-colors" data-id="dz6nnyil9" data-path="src/components/Header.tsx">
              Inicio
            </a>
            <a href="#domotica" className="block py-2 text-gray-700 hover:text-blue-600 transition-colors" data-id="ueum53fdt" data-path="src/components/Header.tsx">
              ¿Qué es la Domótica?
            </a>
            <a href="#soluciones" className="block py-2 text-gray-700 hover:text-blue-600 transition-colors" data-id="cbbterw5q" data-path="src/components/Header.tsx">
              Soluciones
            </a>
            <a href="#servicios" className="block py-2 text-gray-700 hover:text-blue-600 transition-colors" data-id="yhbz6qpn0" data-path="src/components/Header.tsx">
              Servicios
            </a>
            <a href="#proyectos" className="block py-2 text-gray-700 hover:text-blue-600 transition-colors" data-id="505q8t3ty" data-path="src/components/Header.tsx">
              Proyectos
            </a>
            <a href="#testimonios" className="block py-2 text-gray-700 hover:text-blue-600 transition-colors" data-id="hp9sga736" data-path="src/components/Header.tsx">
              Testimonios
            </a>
            <a href="/blog" className="block py-2 text-gray-700 hover:text-blue-600 transition-colors" data-id="mtglr0b0n" data-path="src/components/Header.tsx">
              Blog
            </a>
            <a href="/videos" className="block py-2 text-gray-700 hover:text-blue-600 transition-colors" data-id="8fgxki7ez" data-path="src/components/Header.tsx">
              Videos
            </a>
            <a href="#calculadora" className="block py-2 text-gray-700 hover:text-blue-600 transition-colors" data-id="qbzzjmplg" data-path="src/components/Header.tsx">
              Comparador de Precios
            </a>
            <a href="#contacto" className="block py-2 text-gray-700 hover:text-blue-600 transition-colors" data-id="jd7zk0omm" data-path="src/components/Header.tsx">
              Contacto
            </a>
            <Button className="w-full bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white py-2 rounded-lg font-medium mt-4" data-id="tyco1ea7x" data-path="src/components/Header.tsx">
              Cotización Gratuita
            </Button>
          </div>
        </div>
      }
    </header>);

};

export default Header;